import { useRef, useSyncExternalStore } from 'react';
import { ThemeProvider as StyledComponentsThemeProvider } from 'styled-components';
import { globalThemeManager } from '../../utils/themeManager';
import TrellisStyleSheetManager from '../TrellisStyleSheetManager/TrellisStyleSheetManager';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * The `ThemeProvider` provides the theme object for your app via
 * React Context. Foundations components **will not work without it**.
 * This `ThemeProvider` is used by the `AppProvider` component,
 * which is the top-level component that should wrap your entire app.
 *
 * This component is also used by `hs-test-utils` to wrap all unit test
 * component trees.
 */
export const ThemeProvider = ({
  themeName,
  themeMode,
  children,
  DO_NOT_USE_stylesheetManagerProps = {}
}) => {
  var _prevProps$current, _prevProps$current2;
  // props are for backwards compat until we make all users of the props use the globalThemeManager
  const prevProps = useRef(undefined);

  // eslint-disable-next-line react-hooks/refs
  if (
  // eslint-disable-next-line react-hooks/refs
  ((_prevProps$current = prevProps.current) === null || _prevProps$current === void 0 ? void 0 : _prevProps$current.themeName) !== themeName ||
  // eslint-disable-next-line react-hooks/refs
  ((_prevProps$current2 = prevProps.current) === null || _prevProps$current2 === void 0 ? void 0 : _prevProps$current2.themeMode) !== themeMode) {
    globalThemeManager.setTheme({
      themeName,
      themeMode
    });
    // eslint-disable-next-line react-hooks/refs
    prevProps.current = {
      themeName,
      themeMode
    };
  }
  const theme = useSyncExternalStore(globalThemeManager.subscribe, globalThemeManager.getTheme, globalThemeManager.getTheme);
  return /*#__PURE__*/_jsx(TrellisStyleSheetManager, {
    stylesheetManagerProps: DO_NOT_USE_stylesheetManagerProps,
    children: /*#__PURE__*/_jsx(StyledComponentsThemeProvider, {
      theme: theme,
      children: children
    })
  });
};

/**
 * Storybook uses this method to get the theme manager instance, since it is not available in the Storybook context
 * In regular code, just import the globalThemeManager directly.
 */
ThemeProvider.getThemeManager = () => globalThemeManager;